import React, { DetailedHTMLProps, HTMLAttributes } from 'react'

const OpenWindowSvg = (props: DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>): JSX.Element => {
  return (
    <div {...props}>
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M6.5 3.5H3.5V12.5H12.5V9.5M8.5 7.5L13 3M13 3H9.5M13 3V6.5"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </div>
  )
}

export default OpenWindowSvg
